import React from 'react';
import { Link } from 'react-router-dom';
import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/software-company-components/Footer/Footer";
import SEO from "../../components/SEO";
import "../HRConsultingPage/HRConsulting.css";
import "../../css/animate.css";

function HRConsulting() {
  return (
    <div>
        <SEO
            title="HR Consulting Services | Expert Human Resources Solutions"
            description="Professional HR consulting services to help businesses with recruitment, compliance, employee relations, and performance management. Customized solutions for your human resources needs."
            url="https://www.ufsnetworks.com/hr-consulting"
            image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
            canonicalUrl="https://www.ufsnetworks.com/hr-consulting"
        />
        <Header2 />
        <main>
            <PageTitle
                pageTitle={"HR Consulting Services | Expert Human Resources Solutions"}
                pagesub={"HR Consulting"}
                pageTop={""}
            />
            </main>
            <div className='bannerContainer'>
                <div className='leftSection'>
                    <h2 className='heading'>HR Consulting Services</h2>
                    
                    <p className='text'>At Unified Consultancy Services, we specialize in delivering tailored HR Consulting solutions designed to streamline your workforce strategy and support your long-term business goals. Whether you're a startup or an enterprise, our expertise bridges the gap between talent and technology. </p>
                    <div className='mt-4'>
                        <Link to="/contact" className='contactBtn'>👉 Contact us today for a customized HR consultation</Link>
                    </div>
                </div>
            </div>
            <div class="container-hr">
                <div class="section">
                    <h2 >Full-Service HR Solutions</h2>
                    <p>Our consulting model is built to be flexible and scalable. We provide expert support for:</p>
                    <ul className='custom-list'>
                        <li><strong>Full Time Hiring –</strong> Find and retain top-tier talent that aligns with your company culture and growth plans.</li>
                        <li><strong>Contract Staffing –</strong> Agile workforce solutions to meet project-based or seasonal demands.</li>
                        <li><strong>Consultant Engagement –</strong> Access industry-specific experts without long-term commitments.</li>
                        <li><strong>MSP Solutions –</strong> Centralize your staffing suppliers for better compliance, cost control, and visibility.</li>
                    </ul>
                </div>

                <div class="section">
                    <h2>HR Technical Outsourcing</h2>
                    <p>Leverage our HR Technical Outsourcing services to reduce operational overhead and gain access to specialized recruiting tools, automated HR processes, and real-time analytics. We manage everything from sourcing to onboarding, so you can focus on your core business.</p>
                    <ul className='custom-list'>
                        <li>Reduced time-to-hire</li>
                        <li>Scalable support for ramp-ups</li>
                        <li>Industry-specific expertise</li>
                        <li>Compliance with labor laws and regulations</li>
                    </ul>
                </div>

                <div class="section">
                    <h2>Why Choose Us?</h2>
                    <ul className='custom-list'>
                        <li>Experienced HR Consultants with multi-industry expertise</li>
                        <li>End-to-end support – from job description creation to final onboarding</li>
                        <li>Flexible Engagement Models – choose full time, contract, or consultant-based staffing</li>
                        <li>Technology-Driven MSP Solutions for workforce efficiency</li>
                        <li>Transparent Reporting & Dedicated Account Management</li>
                    </ul>
                </div>

                <div class="cta">
                    <h2 className='text-white'>Ready to Build a Smarter Workforce?</h2>
                    <p className='mb-32'>Whether you need a dedicated HR Consultant, support with Contract hiring, or a complete MSP solution,<br/> we've got you covered. Partner with <strong>Unified Consultancy Services</strong> to power your people strategy.</p>
                    <Link to="/contact" className='contactBtn'>👉 Contact us today for a customized HR consultation</Link>
                </div>
            </div>
            <Footer/>
      <Scrollbar />
      
    </div>
  )
}

export default HRConsulting
